import { createFileRoute } from '@tanstack/react-router';
import { ReportDetailView } from '@/components/report-detail-view';
import { useInspection } from '@/hooks/use-inspection-queries';

export const Route = createFileRoute('/dashboard/inspection/$inspectionId/')({
  component: InspectionDetailPage,
});

function InspectionDetailPage() {
  const { inspectionId } = Route.useParams();
  const { data: inspection } = useInspection(inspectionId);

  if (!inspection) return null;

  return <ReportDetailView report={inspection} />;
}
